import type * as React from 'react'

import {
  CircleCheckBigIcon,
  DropdownMenu,
  IconButton,
} from '@buffer-mono/popcorn'

import type { JSX } from 'react'

import { useBulkActionsMenuContext } from './BulkActionsMenuContext'

export type BulkActionsMenuTriggerProps = {
  children?: React.ReactNode
}

export function BulkActionsMenuTrigger({
  children,
}: BulkActionsMenuTriggerProps): JSX.Element {
  const { entity } = useBulkActionsMenuContext()

  return (
    <DropdownMenu.Trigger>
      {children ?? (
        <IconButton
          size="medium"
          variant="tertiary"
          label="Bulk resolve"
          tooltip={
            entity === 'mentions'
              ? 'Bulk resolve mentions'
              : 'Bulk resolve comments'
          }
        >
          <CircleCheckBigIcon />
        </IconButton>
      )}
    </DropdownMenu.Trigger>
  )
}
